export default __webpack_public_path__ + "static/media/riepilogo.bb39128c.svg";